import React, { useEffect } from 'react';

import RiskIcon from '../../assets/images/meters/risks.svg';
import ActionIcon from '../../assets/images/meters/actions.svg';
import ControlIcon from '../../assets/images/meters/controls.svg';
import { AiOutlineRadarChart } from "react-icons/ai";

import { connect } from "react-redux";
import { compose } from "redux";

import { getComplianceMetrics } from "../../store/actions/dashboardActions";

const ComplianceMeters = ({ metrics, getComplianceMetricsFN, compliance_id }) => {
    
    useEffect(() => {
        ////console.log("compliance_id", compliance_id)
        getComplianceMetricsFN(compliance_id);
    }, [compliance_id]);

    return (
        <div className="grid w-full min-w-0 grid-cols-3 gap-2 px-2 py-3 sm:gap-3 sm:px-4 md:flex md:flex-wrap md:items-center md:justify-center md:gap-x-8 md:gap-y-3 lg:gap-x-20 xl:gap-x-32 bg-white">
            {/* Compliance Risks */}
            <div className="flex min-w-0 items-center justify-center gap-1.5 sm:gap-2 md:justify-start">
                <img
                    src={RiskIcon}
                    alt="Compliance Risks Icon"
                    className="h-7 w-7 shrink-0 sm:h-9 sm:w-9 md:h-10 md:w-10"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-sm font-bold sm:text-base md:text-xl">{metrics.risks}</div>
                    <div className="text-[9px] leading-tight text-gray-600 sm:text-[11px] md:text-base">
                        <span className="hidden min-[360px]:inline">Compliance </span>Risks
                    </div>
                </div>
            </div>

            {/* Compliance Controls */}
            <div className="flex min-w-0 items-center justify-center gap-1.5 sm:gap-2 md:justify-start">
                <img
                    src={ControlIcon}
                    alt="Compliance Controls Icon"
                    className="h-7 w-7 shrink-0 sm:h-9 sm:w-9 md:h-10 md:w-10"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-sm font-bold sm:text-base md:text-xl">{metrics.controls}</div>
                    <div className="text-[9px] leading-tight text-gray-600 sm:text-[11px] md:text-base">
                        <span className="hidden min-[360px]:inline">Compliance </span>Controls
                    </div>
                </div>
            </div>

            {/* Compliance Actions */}
            <div className="flex min-w-0 items-center justify-center gap-1.5 sm:gap-2 md:justify-start">
                <img
                    src={ActionIcon}
                    alt="Compliance Actions Icon"
                    className="h-6 w-6 shrink-0 sm:h-8 sm:w-8"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-sm font-bold sm:text-base md:text-xl">{metrics.actions}</div>
                    <div className="text-[9px] leading-tight text-gray-600 sm:text-[11px] md:text-base">
                        <span className="hidden min-[360px]:inline">Compliance </span>Actions
                    </div>
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    ////console.log("Compince satte", state.dashboard.complianceMetrics)
    return {
        metrics: state.dashboard.complianceMetrics, 
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getComplianceMetricsFN: (c) => dispatch(getComplianceMetrics(c)), 
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceMeters);